import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";
import { B2B_PARTNERS } from "../../Config/ApiUrl-CPB";
import { mapGetters } from "vuex";

export default {
    mixins: [DatatableHelperMixin],
    data() {
        return {
            options: {
                name: this.$t('b2b_partners'),
                url: null,
                showCount: true,
                showClearFilter: true,
                showHeader: true,
                columns: [
                    { title: this.$t('B2B Partner Name'), type: 'text', key: 'name' },
                    { title: this.$t('Company Name'), type: 'text', key: 'company_name' },
                    {
                        title: this.$t('Branch'),
                        type: 'custom-html',
                        key: 'branch',
                        modifier: (value) => value ? `<p>${value.name}</p>` : '-',
                    },
                    { title: this.$t('Phone'), type: 'text', key: 'phone_1' },
                    { title: this.$t('Email'), type: 'text', key: 'email' },
                    { title: this.$t('actions'), type: 'action', key: 'invoice', isVisible: true },
                ],
                actionType: "default",
                actions: [
                    {
                        title: this.$t('edit'),
                        icon: 'edit',
                        type: 'modal',
                        component: 'app-b2b-partner-modal',
                        modalId: 'app-modal',
                        modifier: () => this.$can('update_customers'),
                    },
                    {
                        title: this.$t('Pricelist'),
                        icon: 'list',
                        type: 'modal',
                        component: 'app-modal',
                        modalId: 'app-modal',
                        modifier: () => this.$can('update_customers'),
                    },
                    {
                        title: this.$t('delete'),
                        type: 'modal',
                        icon: 'trash-2',
                        component: 'app-confirmation-modal',
                        modalId: 'app-confirmation-modal',
                        url: B2B_PARTNERS,
                        name: 'delete',
                        modifier: () => this.$can('delete_customers'),
                    }
                ],
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                search: true,
            },
        }
    },
    computed: {
        ...mapGetters(['getBranchOrWarehouseId']),
    },
    mounted() {
        this.updateUrl(B2B_PARTNERS);
    },
    watch: {
        getBranchOrWarehouseId: {
            immediate: false,
            handler() {
                this.updateUrl(B2B_PARTNERS);
            }
        }
    },
}
